import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'bootstrap/dist/css/bootstrap.min.css';
import classNames from 'classnames';
import ModalTrocarConta from 'components/modal/ModalTrocarConta';
import Acao from 'model/administracao/cadastro/Acao';
import MenuOpcao from 'model/menu/MenuOpcao';
import AprovacaoFaixaValoresCadastro from 'pages/administracao/cadastro/aprovacaofaixavalores/AprovacaoFaixaValoresCadastro';
import AprovacaoFaixaValoresListagem from 'pages/administracao/cadastro/aprovacaofaixavalores/AprovacaoFaixaValoresListagem';
import CentroCustoCadastro from 'pages/administracao/cadastro/centrocusto/CentroCustoCadastro';
import CentroCustoListagem from 'pages/administracao/cadastro/centrocusto/CentroCustoListagem';
import ContaCadastro from 'pages/administracao/cadastro/conta/ContaCadastro';
import ContaListagem from 'pages/administracao/cadastro/conta/ContaListagem';
import ContaParametroCadastro from 'pages/administracao/cadastro/contaParametro/ContaParametroCadastro';
import ContaParametroListagem from 'pages/administracao/cadastro/contaParametro/ContaParametroListagem';
import GrupoUsuariosCadastro from 'pages/administracao/cadastro/grupoUsuarios/GrupoUsuariosCadastro';
import GrupoUsuariosListagem from 'pages/administracao/cadastro/grupoUsuarios/GrupoUsuariosListagem';
import NivelAprovacaoCadastro from 'pages/administracao/cadastro/nivelaprovacao/NivelAprovacaoCadastro';
import NivelAprovacaoListagem from 'pages/administracao/cadastro/nivelaprovacao/NivelAprovacaoListagem';
import PerfilCadastro from 'pages/administracao/cadastro/perfil/PerfilCadastro';
import PerfilListagem from 'pages/administracao/cadastro/perfil/PerfilListagem';
import PessoaCadastro from 'pages/administracao/cadastro/pessoa/PessoaCadastro';
import PessoaListagem from 'pages/administracao/cadastro/pessoa/PessoaListagem';
import FamiliaProdutoCadastro from 'pages/administracao/cadastro/produto/familia/FamiliaProdutoCadastro';
import FamiliaProdutoListagem from 'pages/administracao/cadastro/produto/familia/FamiliaProdutoListagem';
import OrigemProdutoCadastro from 'pages/administracao/cadastro/produto/origem/OrigemProdutoCadastro';
import OrigemProdutoListagem from 'pages/administracao/cadastro/produto/origem/OrigemProdutoListagem';
import ProdutoCadastro from 'pages/administracao/cadastro/produto/ProdutoCadastro';
import ProdutoFornecedorCadastro from 'pages/administracao/cadastro/produto/produtoFornecedor/ProdutoFornecedorCadastro';
import ProdutoFornecedorListagem from 'pages/administracao/cadastro/produto/produtoFornecedor/ProdutoFornecedorListagem';
import ProdutoClienteCadastro from 'pages/fiscal/produtoCliente/ProdutoClienteCadastro';
import ProdutoClienteListagem from 'pages/fiscal/produtoCliente/ProdutoClienteListagem';
import ProdutoListagem from 'pages/administracao/cadastro/produto/ProdutoListagem';
import SetorCadastro from 'pages/administracao/cadastro/setor/SetorCadastro';
import SetorListagem from 'pages/administracao/cadastro/setor/SetorListagem';
import AcaoAuditoriaCadastro from 'pages/auditoria5s/acao/AcaoAuditoriaCadastro';
import AcaoAuditoriaListagem from 'pages/auditoria5s/acao/AcaoAuditoriaListagem';
import AcaoAuditoriaResponderPage from 'pages/auditoria5s/acao/AcaoAuditoriaResponderPage';
import MinhasAcoesAuditoriaPage from 'pages/auditoria5s/acao/MinhasAcoesAuditoriaPage';
import AuditoriaCadastro from 'pages/auditoria5s/auditoria/AuditoriaCadastro';
import AuditoriaListagem from 'pages/auditoria5s/auditoria/AuditoriaListagem';
import ClassificacaoRequisitoCadastro from 'pages/auditoria5s/classificacaoRequisito/ClassificacaoRequisitoCadastro';
import ClassificacaoRequisitoListagem from 'pages/auditoria5s/classificacaoRequisito/ClassificacaoRequisitoListagem';
import AuditoriaDashboard from 'pages/auditoria5s/dashboard/AuditoriaDashboard';
import AuditoriaNaoConformidadeDashboard from 'pages/auditoria5s/dashboard/AuditoriaNaoConformidadeDashboard';
import AuditoriaExecutarItemPage from 'pages/auditoria5s/execucao/AuditoriaExecutarItemPage';
import AuditoriaExecutarPage from 'pages/auditoria5s/execucao/AuditoriaExecutarPage';
import MinhasAuditorias from 'pages/auditoria5s/execucao/MinhasAuditoriasPage';
import ItemAuditoriaListagem from 'pages/auditoria5s/ItemAuditoriaListagem';
import PlanoAuditoriaCadastro from 'pages/auditoria5s/planoAuditoria/PlanoAuditoriaCadastro';
import PlanoAuditoriaListagem from 'pages/auditoria5s/planoAuditoria/PlanoAuditoriaListagem';
import RequisitoAuditoriaCadastro from 'pages/auditoria5s/requisitoAuditoria/RequisitoAuditoriaCadastro';
import RequisitoAuditoriaListagem from 'pages/auditoria5s/requisitoAuditoria/RequisitoAuditoriaListagem';
import CallbackDrivePage from 'pages/CallbackDrivePage';
import DashboardGeralPage from 'pages/DashboardGeralPage';
import CategoriaDocumentoCadastro from 'pages/documentos/CategoriaDocumentoCadastro';
import CategoriaDocumentoListagem from 'pages/documentos/CategoriaDocumentoListagem';
import DocumentoCadastro from 'pages/documentos/DocumentoCadastro';
import { DocumentoDashboardPage } from 'pages/documentos/DocumentoDashboardPage';
import DocumentoFluxoPage from 'pages/documentos/DocumentoFluxoPage';
import DocumentoListagem from 'pages/documentos/DocumentoListagem';
import DocumentoPastaLixeiraPage from 'pages/documentos/DocumentoPastaLixeiraPage';
import DocumentoPastaPage from 'pages/documentos/DocumentoPastaPage';
import DocumentoPropriedades from 'pages/documentos/DocumentoPropriedades';
import DocumentoSolicitacaoRevisaoListagem from 'pages/documentos/DocumentoSolicitacaoRevisaoListagem';
import DocumentosPendenciasListagem from 'pages/documentos/DocumentosPendeciasListagem';
import FeriadoAdmCadastro from 'pages/feriado/FeriadoAdmCadastro';
import FeriadoAdmListagem from 'pages/feriado/FeriadoAdmListagem';
import FeriadoCadastro from 'pages/feriado/FeriadoCadastro';
import FeriadoListagem from 'pages/feriado/FeriadoListagem';
import ClassificacaoFiscalCadastro from 'pages/fiscal/classificacaoFiscal/ClassificacaoFiscalCadastro';
import ClassificacaoFiscalListagem from 'pages/fiscal/classificacaoFiscal/ClassificacaoFiscalListagem';
import CondicaoPagamentoCadastro from 'pages/fiscal/condicaoPagamento/CondicaoPagamentoCadastro';
import CondicaoPagamentoListagem from 'pages/fiscal/condicaoPagamento/CondicaoPagamentoListagem';
import FormaPagamentoCadastro from 'pages/fiscal/formaPagamento/FormaPagamentoCadastro';
import FormaPagamentoListagem from 'pages/fiscal/formaPagamento/FormaPagamentoListagem';
import RepresentanteCadastro from 'pages/fiscal/representante/RepresentanteCadastro';
import RepresentanteListagem from 'pages/fiscal/representante/RepresentanteListagem';
import SerieNotaFiscalCadastro from 'pages/fiscal/serieNotaFiscal/SerieNotaFiscalCadastro';
import SerieNotaFiscalListagem from 'pages/fiscal/serieNotaFiscal/SerieNotaFiscalListagem';
import TransacaoNotaFiscalCadastro from 'pages/fiscal/transacaoNotaFiscal/TransacaoNotaFiscalCadastro';
import TransacaoNotaFiscalListagem from 'pages/fiscal/transacaoNotaFiscal/TransacaoNotaFiscalListagem';
import UnidadeOrganizacionalCertificadoCadastro from 'pages/fiscal/unidadeOrganizacionalCertificado/UnidadeOrganizacionalCertificadoCadastro';
import CicloFiscal from 'pages/fiscal/cicloFiscal/CicloFiscalPage';
import ParametrosFiscaisCadastro from 'pages/fiscal/parametrosFiscais/ParametrosFiscaisCadastro';
import NotaFiscalSaidaEdicao from 'pages/vendas/notaFiscalSaida/NotaFiscalSaidaEdicao';
import NotaFiscalSaidaEmissao from 'pages/vendas/notaFiscalSaida/NotaFiscalSaidaEmissao';
import NotaFiscalSaidaListagem from 'pages/vendas/notaFiscalSaida/NotaFiscalSaidaListagem';
import NotaFiscalSaidaConsulta from 'pages/vendas/notaFiscalSaida/NotaFiscalSaidaConsulta';
import NotaFiscalSaidaCartaCorrecao from 'pages/vendas/notaFiscalSaida/NotaFiscalSaidaCartaCorrecao';
import AtividadeApontamentoCadastro from 'pages/gestao/atividades/apontamento/AtividadeApontamentoCadastro';
import AtividadeApontamentoFiltroListagem from 'pages/gestao/atividades/apontamento/AtividadeApontamentoFiltroListagem';
import AtividadeMeusApontamentosListagem from 'pages/gestao/atividades/apontamento/AtividadeMeusApontamentosListagem';
import AtividadeCadastro from 'pages/gestao/atividades/atividade/AtividadeCadastro';
import AtividadeListagem from 'pages/gestao/atividades/atividade/AtividadeListagem';
import HorarioCadastro from 'pages/gestao/atividades/horario/HorarioCadastro';
import HorarioListagem from 'pages/gestao/atividades/horario/HorarioListagem';
import GestaoFrotasDashboard from 'pages/gestao/frotas/dashboard/GestaoFrotasDashboard';
import ItemInspecaoFrotaCadastro from 'pages/gestao/frotas/itemInspecaoFrota/ItemInspecaoFrotaCadastro';
import ItemInspecaoFrotaListagem from 'pages/gestao/frotas/itemInspecaoFrota/ItemInspecaoFrotaListagem';
import ItemManutencaoVeiculoListagem from 'pages/gestao/frotas/itemManutencaoVeiculo/ItemManutencaoVeiculoListagem';
import ManutencaoPendenteListagem from 'pages/gestao/frotas/manutencaoPendente/ManutencaoPendenteListagem';
import ManutencaoVeiculoCadastro from 'pages/gestao/frotas/manutencaoVeiculo/ManutencaoVeiculoCadastro';
import ManutencaoVeiculoListagem from 'pages/gestao/frotas/manutencaoVeiculo/ManutencaoVeiculoListagem';
import MarcaVeiculoCadastro from 'pages/gestao/frotas/marcaVeiculo/MarcaVeiculoCadastro';
import MarcaVeiculoListagem from 'pages/gestao/frotas/marcaVeiculo/MarcaVeiculoListagem';
import VeiculoCadastro from 'pages/gestao/frotas/veiculo/VeiculoCadastro';
import VeiculoListagem from 'pages/gestao/frotas/veiculo/VeiculoListagem';
import VeiculoViagemConsultar from 'pages/gestao/frotas/veiculoViagem/VeiculoViagemConsultar';
import VeiculoViagemDashboardPage from 'pages/gestao/frotas/veiculoViagem/VeiculoViagemDashboardPage';
import VeiculoViagemListagem from 'pages/gestao/frotas/veiculoViagem/VeiculoViagemListagem';
import VeiculoViagemRastreamentoPage from 'pages/gestao/frotas/veiculoViagem/VeiculoViagemRastreamentoPage';
import HelpdeskBatePapoPage from 'pages/helpdesk/helpdeskBatePapo/HelpdeskBatePapoPage';
import HelpdeskChamadoCadastro from 'pages/helpdesk/helpdeskChamado/HelpdeskChamadoCadastro';
import HelpdeskChamadoListagem from 'pages/helpdesk/helpdeskChamado/HelpdeskChamadoListagem';
import HelpdeskMeusChamadosListagem from 'pages/helpdesk/helpdeskChamado/HelpdeskMeusChamadosListagem';
import HelpdeskTipoChamadoCadastro from 'pages/helpdesk/helpdeskTipoChamado/HelpdeskTipoChamadoCadastro';
import HelpdeskTipoChamadoListagem from 'pages/helpdesk/helpdeskTipoChamado/HelpdeskTipoChamadoListagem';
import IndicadorDashboardPage from 'pages/indicadores/dashboard/IndicadorDashboardPage';
import IndicadorCadastro from 'pages/indicadores/indicador/IndicadorCadastro';
import IndicadorListagem from 'pages/indicadores/indicador/IndicadorListagem';
import IndicadorMinhasAnalisesColetasListagem from 'pages/indicadores/IndicadorMinhasAnalisesColetasListagem';
import IndicadorMinhasColetasListagem from 'pages/indicadores/IndicadorMinhasColetasListagem';
import ProcessoCadastro from 'pages/indicadores/processo/ProcessoCadastro';
import ProcessoListagem from 'pages/indicadores/processo/ProcessoListagem';
import UnidadeOrganizacionalCadastro from 'pages/indicadores/unidadeOrganizacional/UnidadeOrganizacionalCadastro';
import UnidadeOrganizacionalListagem from 'pages/indicadores/unidadeOrganizacional/UnidadeOrganizacionalListagem';
import ApontamentoDefeitoListagem from 'pages/meta/producao/apontamentos/ApontamentoDefeitoListagem';
import ApontamentoMotivoParadaListagem from 'pages/meta/producao/apontamentos/ApontamentoMotivoParadaListagem';
import ApontamentoOperacaoListagem from 'pages/meta/producao/apontamentos/ApontamentoOperacaoListagem';
import DefeitoFabricacaoCadastro from 'pages/meta/producao/defeito/DefeitoFabricacaoCadastro';
import DefeitoFabricacaoListagem from 'pages/meta/producao/defeito/DefeitoFabricacaoListagem';
import HorarioDiaCadastro from 'pages/meta/producao/horarioDia/HorarioDiaCadastro';
import HorarioDiaListagem from 'pages/meta/producao/horarioDia/HorarioDiaListagem';
import MetaProducaoCadastro from 'pages/meta/producao/metaProducao/MetaProducaoCadastro';
import MetaProducaoListagem from 'pages/meta/producao/metaProducao/MetaProducaoListagem';
import MetaProducaoDashboard from 'pages/meta/producao/MetaProducaoDashboard';
import MetaProducaoDefeitoDashboard from 'pages/meta/producao/MetaProducaoDefeitoDashboard';
import MotivoParadaCadastro from 'pages/meta/producao/motivoParada/MotivoParadaCadastro';
import MotivoParadaListagem from 'pages/meta/producao/motivoParada/MotivoParadaListagem';
import OperacaoProducaoCadastro from 'pages/meta/producao/operacao/OperacaoProducaoCadastro';
import OperacaoProducaoListagem from 'pages/meta/producao/operacao/OperacaoProducaoListagem';
import EmprestimoPatrimonioCadastro from 'pages/patrimonio/emprestimoPatrimonio/EmprestimoPatrimonioCadastro';
import EmprestimoPatrimonioListagem from 'pages/patrimonio/emprestimoPatrimonio/EmprestimoPatrimonioListagem';
import EstoqueInutilizavelConsulta from 'pages/patrimonio/estoqueInutilizavel/EstoqueInutilizavelConsulta';
import ItemEmprestimoListagem from 'pages/patrimonio/itemEmprestimo/ItemEmprestimoListagem';
import LocalCadastro from 'pages/patrimonio/local/LocalCadastro';
import LocalListagem from 'pages/patrimonio/local/LocalListagem';
import MovimentoPatrimonioListagem from 'pages/patrimonio/movimentoPatrimonio/MovimentoPatrimonioListagem';
import PatrimonioCadastro from 'pages/patrimonio/patrimonio/PatrimonioCadastro';
import PatrimonioListagem from 'pages/patrimonio/patrimonio/PatrimonioListagem';
import EscolherEstagio from 'pages/producao/apontamento/EscolherEstagio';
import EstagioApontamentoCadastro from 'pages/producao/apontamento/EstagioApontamentoCadastro';
import EstagiosApontamentoListagem from 'pages/producao/apontamento/EstagiosApontamentoListagem';
import EstagioCadastro from 'pages/producao/estagio/EstagioCadastro';
import EstagioListagem from 'pages/producao/estagio/EstagioListagem';
import GerarOP from 'pages/producao/gerarOP/GerarOP';
import OrdemProducaoCadastro from 'pages/producao/ordemProducao/OrdemProducaoCadastro';
import OrdemProducaoListagem from 'pages/producao/ordemProducao/OrdemProducaoListagem';
import PedidoCadastro from 'pages/producao/pedido/PedidoCadastro';
import PedidoListagem from 'pages/producao/pedido/PedidoListagem';
import RoteiroCadastro from 'pages/producao/roteiro/RoteiroCadastro';
import RoteiroListagem from 'pages/producao/roteiro/RoteiroListagem';
import InspecaoQualidadeCadastro from 'pages/qualidade/inspecaoQualidade/InspecaoQualidadeCadastro';
import InspecaoQualidadeListagem from 'pages/qualidade/inspecaoQualidade/InspecaoQualidadeListagem';
import PlanoInspecaoCadastro from 'pages/qualidade/planoInspecao/PlanoInspecaoCadastro';
import PlanoInspecaoListagem from 'pages/qualidade/planoInspecao/PlanoInspecaoListagem';
import QualidadeProdutoAcabadoCadastro from 'pages/qualidade/produtoAcabado/QualidadeProdutoAcabadoCadastro';
import QualidadeProdutoAcabadoListagem from 'pages/qualidade/produtoAcabado/QualidadeProdutoAcabadoListagem';
import RecebimentoCadastro from 'pages/qualidade/recebimento/RecebimentoCadastro';
import RecebimentoListagem from 'pages/qualidade/recebimento/RecebimentoListagem';
import AjusteEstoqueCadastro from 'pages/suprimentos/AjusteEstoqueCadastro';
import DepositoCadastro from 'pages/suprimentos/deposito/DepositoCadastro';
import DepositoListagem from 'pages/suprimentos/deposito/DepositoListagem';
import EstoqueConsulta from 'pages/suprimentos/EstoqueConsulta';
import IntegracaoMovimentoListagem from 'pages/suprimentos/integracao/IntegracaoMovimentoListagem';
import MovimentoEstoqueConsulta from 'pages/suprimentos/MovimentoEstoqueConsulta';
import NotaFiscalEntradaCadastro from 'pages/suprimentos/notaFiscal/NotaFiscalEntradaCadastro';
import NotaFiscalEntradaListagem from 'pages/suprimentos/notaFiscal/NotaFiscalEntradaListagem';
import SuprimentosDashboard from 'pages/suprimentos/SuprimentosDashboard';
import TransacaoCadastro from 'pages/suprimentos/transacao/TransacaoCadastro';
import TransacaoListagem from 'pages/suprimentos/transacao/TransacaoListagem';
import TransferenciaCadastro from 'pages/suprimentos/TransferenciaCadastro';
import ColetaCadastro from 'pages/transportes/coleta/ColetaCadastro';
import ColetaListagem from 'pages/transportes/coleta/ColetaListagem';
import CteCadastro from 'pages/transportes/cte/CteCadastro';
import CteListagem from 'pages/transportes/cte/CteListagem';
import MdfeCadastro from 'pages/transportes/mdfe/MdfeCadastro';
import MdfeListagem from 'pages/transportes/mdfe/MdfeListagem';
import { RastreamentoPage } from 'pages/transportes/rastreamento/RastreamentoPage';
import RotaCadastro from 'pages/transportes/rota/RotaCadastro';
import RotaListagem from 'pages/transportes/rota/RotaListagem';
import UsuarioCadastro from 'pages/usuario/UsuarioCadastro';
import UsuarioListagem from 'pages/usuario/UsuarioListagem';
import UsuarioPerfilCadastro from 'pages/usuario/UsuarioPerfilCadastro';
import ViagemAprovacaoListagem from 'pages/viagem/aprovacao/ViagemAprovacaoListagem';
import ViagemDespesaAprovacaoListagem from 'pages/viagem/despesaAprovacao/ViagemDespesaAprovacaoListagem';
import MinhasViagensListagem from 'pages/viagem/MinhasViagensListagem';
import ViagemTipoDespesaCadastro from 'pages/viagem/tipoDespesa/ViagemTipoDespesaCadastro';
import ViagemTipoDespesaListagem from 'pages/viagem/tipoDespesa/ViagemTipoDespesaListagem';
import ViagemCadastro from 'pages/viagem/ViagemCadastro';
import ViagemDespesaListagem from 'pages/viagem/ViagemDespesaListagem';
import ViagemListagem from 'pages/viagem/ViagemListagem';
import { addLocale, locale } from 'primereact/api';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/nova/theme.css';
import { ScrollPanel } from 'primereact/scrollpanel';
import publicRoutes from 'PublicRoutes';
import { Component } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import AppInlineProfile from './AppInlineProfile';
import { AppMenu } from './AppMenu';
import { AppTopbar } from './AppTopbar';
import './layout.css';
import AuditoriaClassificacaoNotaPage from 'pages/auditoria5s/AuditoriaClassificacaoNotaPage';

type Props = {
    acoes: Acao[],
    listaOpcoes: MenuOpcao[],
    nomeUsuario: string,
    nomeConta: string,
    nomeSetor: string,
}

type State = {
    layoutColorMode: string,
    staticMenuInactive: boolean,
    visibleModalTrocarConta?: boolean
};

class Menu extends Component<Props, State> {

    state = {
        layoutColorMode: 'light',
        staticMenuInactive: false,
        visibleModalTrocarConta: false
    }

    constructor(props: any) {
        super(props);

        locale('pt-BR');
        addLocale('pt-BR', {
            firstDayOfWeek: 0,
            dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            today: "Hoje",
            clear: "Limpar"
        });

        this.onWrapperClick = this.onWrapperClick.bind(this);
        this.onToggleMenu = this.onToggleMenu.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
    }

    menuClick = false;

    componentDidMount(): void {
        if (!this.isDesktop()) {
            this.setState({
                staticMenuInactive: true
            });
        } else {
            this.setState({
                staticMenuInactive: localStorage.getItem('layout-menu-static-inactive') === 'true'
            });
        }
    }

    onWrapperClick(event: any) {
        this.menuClick = false;
    }

    onToggleMenu(event: any) {
        this.menuClick = true;
        this.setState({
            staticMenuInactive: !this.state.staticMenuInactive
        }, () => { localStorage.setItem('layout-menu-static-inactive', String(this.state.staticMenuInactive)) });

        if (event) {
            event.preventDefault();
        }

    }

    onSidebarClick(event: any) {
        this.menuClick = true;
    }

    onMenuItemClick(event: any) {
        if (!this.isDesktop() && (!event.item.subItems || event.item.subItems.length < 1)) {
            this.onToggleMenu(null);
        } else if (this.state.staticMenuInactive) {
            this.onToggleMenu(null);
        }
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    render() {
        let wrapperClass = classNames('layout-wrapper', {
            'layout-static': true,
            'layout-static-sidebar-inactive': this.state.staticMenuInactive,
        });
        let sidebarClassName = classNames("layout-sidebar");
        return (
            <div className={wrapperClass} onClick={this.onWrapperClick}>
                {this.state.visibleModalTrocarConta ? <ModalTrocarConta visible={this.state.visibleModalTrocarConta} onHide={() => { this.setState({ visibleModalTrocarConta: false }) }} /> : null}
                <AppTopbar onToggleMenu={this.onToggleMenu} />
                <div className={sidebarClassName} onClick={this.onSidebarClick}>

                    <ScrollPanel style={{ height: '100%' }}>
                        <div className="layout-sidebar-scroll-content" style={{ paddingTop: 16 }}>
                            <div className="menu-container-imgs">
                                <FontAwesomeIcon icon="bars" className="menu-icon-toggle" style={{ color: "white" }} onClick={this.onToggleMenu} />
                                <Link to={"/"} >
                                    <img src='/empx.png' className="menu-img-logo" alt="logo" />
                                </Link>
                            </div>
                            <div className="nome-conta" style={{ textAlign: 'center', color: 'white', alignItems: "center", flexDirection: 'column', display: 'flex', padding: 10 }}>
                                <span style={{ fontWeight: "bold" }}>{this.props.nomeConta}</span>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 4 }} onClick={() => { this.setState({ visibleModalTrocarConta: true }) }}>
                                    <span style={{ textDecoration: "underline", cursor: "pointer", padding: 8 }}>Trocar conta</span>
                                    <i className='pi pi-arrow-right-arrow-left'></i>
                                </div>
                            </div>

                            <AppInlineProfile nmPessoa={this.props.nomeUsuario} nmSetor={this.props.nomeSetor} menuAberto={!this.state.staticMenuInactive} {...this.props} />
                            <AppMenu model={this.props.listaOpcoes} menuAberto={!this.state.staticMenuInactive} acoes={this.props.acoes} onMenuItemClick={this.onMenuItemClick} />
                        </div>

                    </ScrollPanel>

                </div>

                <div className="layout-main">

                    <Routes>
                        {publicRoutes()}

                        <Route path="/" element={<DashboardGeralPage />} />
                        <Route path="/contas" element={<ContaListagem />} />
                        <Route path="/conta/cadastrar" element={<ContaCadastro />} />
                        <Route path="/conta/editar/:id" element={<ContaCadastro />} />
                        <Route path="/parametros" element={<ContaParametroListagem />} />
                        <Route path="/parametro/cadastrar" element={<ContaParametroCadastro />} />
                        <Route path="/parametro/editar/:id" element={<ContaParametroCadastro />} />
                        <Route path="/perfis" element={<PerfilListagem />} />
                        <Route path="/perfil/cadastrar" element={<PerfilCadastro />} />
                        <Route path="/perfil/editar/:id" element={<PerfilCadastro />} />
                        <Route path="/usuarios" element={<UsuarioListagem />} />
                        <Route path="/usuario/perfil" element={<UsuarioPerfilCadastro />} />
                        <Route path="/usuario/cadastrar" element={<UsuarioCadastro />} />
                        <Route path="/usuario/editar/:id" element={<UsuarioCadastro />} />
                        <Route path="/grupoUsuarios" element={<GrupoUsuariosListagem />} />
                        <Route path="/grupoUsuarios/cadastrar" element={<GrupoUsuariosCadastro />} />
                        <Route path="/grupoUsuarios/editar/:id" element={<GrupoUsuariosCadastro />} />
                        <Route path="/setor" element={<SetorListagem />} />
                        <Route path="/setor/cadastrar" element={<SetorCadastro />} />
                        <Route path="/setor/editar/:id" element={<SetorCadastro />} />
                        <Route path="/classificacaoPorNota" element={<AuditoriaClassificacaoNotaPage />} />

                        <Route path="/planosAuditoria" element={<PlanoAuditoriaListagem />} />
                        <Route path="/planoAuditoria/cadastrar" element={<PlanoAuditoriaCadastro />} />
                        <Route path="/planoAuditoria/editar/:id" element={<PlanoAuditoriaCadastro />} />

                        <Route path="/classificacaoRequisito" element={<ClassificacaoRequisitoListagem />} />
                        <Route path="/classificacaoRequisito/cadastrar" element={<ClassificacaoRequisitoCadastro />} />
                        <Route path="/classificacaoRequisito/editar/:id" element={<ClassificacaoRequisitoCadastro />} />

                        <Route path="/requisitoAuditoria" element={<RequisitoAuditoriaListagem />} />
                        <Route path="/requisitoAuditoria/cadastrar" element={<RequisitoAuditoriaCadastro />} />
                        <Route path="/requisitoAuditoria/editar/:id" element={<RequisitoAuditoriaCadastro />} />

                        <Route path="/auditoria" element={<AuditoriaListagem />} />
                        <Route path="/auditoria/editar/:id" element={<AuditoriaCadastro />} />

                        <Route path="/minhasAuditorias" element={<MinhasAuditorias />} />
                        <Route path="/minhasAuditorias/executar/:id" element={<AuditoriaExecutarPage />} />
                        <Route path="/minhasAuditorias/executar/item/:id" element={<AuditoriaExecutarItemPage />} />

                        <Route path="/auditoria/dashboard" element={<AuditoriaDashboard />} />
                        <Route path="/auditoria/dashboard/naoConformidades" element={<AuditoriaNaoConformidadeDashboard />} />

                        <Route path="/acoesAuditoria" element={<AcaoAuditoriaListagem />} />
                        <Route path="/acaoAuditoria/editar/:id" element={<AcaoAuditoriaCadastro />} />
                        <Route path="/minhasAcoesAuditoria" element={<MinhasAcoesAuditoriaPage />} />
                        <Route path="/minhasAcoesAuditoria/:id" element={<AcaoAuditoriaResponderPage />} />
                        

                        <Route path="/itemAuditoria" element={<ItemAuditoriaListagem />} />

                        <Route path="/pessoas" element={<PessoaListagem />} />
                        <Route path="/pessoa/cadastrar" element={<PessoaCadastro />} />
                        <Route path="/pessoa/editar/:id" element={<PessoaCadastro />} />

                        <Route path="/origemProduto" element={<OrigemProdutoListagem />} />
                        <Route path="/origemProduto/cadastrar" element={<OrigemProdutoCadastro />} />
                        <Route path="/origemProduto/editar/:id" element={<OrigemProdutoCadastro />} />

                        <Route path="/familiaProduto" element={<FamiliaProdutoListagem />} />
                        <Route path="/familiaProduto/cadastrar" element={<FamiliaProdutoCadastro />} />
                        <Route path="/familiaProduto/editar/:id" element={<FamiliaProdutoCadastro />} />

                        <Route path="/produto" element={<ProdutoListagem />} />
                        <Route path="/produto/cadastrar" element={<ProdutoCadastro />} />
                        <Route path="/produto/editar/:id" element={<ProdutoCadastro />} />

                        <Route path="/produtoFornecedor" element={<ProdutoFornecedorListagem />} />
                        <Route path="/produtoFornecedor/cadastrar" element={<ProdutoFornecedorCadastro />} />
                        <Route path="/produtoFornecedor/editar/:id" element={<ProdutoFornecedorCadastro />} />
                        <Route path="/produtoCliente" element={<ProdutoClienteListagem />} />
                        <Route path="/produtoCliente/cadastrar" element={<ProdutoClienteCadastro />} />
                        <Route path="/produtoCliente/editar/:id" element={<ProdutoClienteCadastro />} />

                        <Route path="/deposito" element={<DepositoListagem />} />
                        <Route path="/deposito/cadastrar" element={<DepositoCadastro />} />
                        <Route path="/deposito/editar/:id" element={<DepositoCadastro />} />

                        <Route path="/transacao" element={<TransacaoListagem />} />
                        <Route path="/transacao/cadastrar" element={<TransacaoCadastro />} />
                        <Route path="/transacao/editar/:id" element={<TransacaoCadastro />} />

                        <Route path="/transferenciaEstoque" element={<TransferenciaCadastro />} />
                        <Route path="/ajusteEstoque" element={<AjusteEstoqueCadastro />} />

                        <Route path="/estoque" element={<EstoqueConsulta />} />
                        <Route path="/movimentoEstoque" element={<MovimentoEstoqueConsulta />} />
                        <Route path="/integracao/movimentoEstoque" element={<IntegracaoMovimentoListagem />} />

                        <Route path="/notaFiscalEntrada" element={<NotaFiscalEntradaListagem />} />
                        <Route path="/notaFiscalEntrada/cadastrar" element={<NotaFiscalEntradaCadastro />} />
                        <Route path="/notaFiscalEntrada/editar/:id" element={<NotaFiscalEntradaCadastro />} />

                        <Route path="/suprimentos/dashboard" element={<SuprimentosDashboard />} />

                        <Route path="/atividades" element={<AtividadeListagem />} />
                        <Route path="/atividade/cadastrar" element={<AtividadeCadastro />} />
                        <Route path="/atividade/editar/:id" element={<AtividadeCadastro />} />

                        <Route path="/horarios" element={<HorarioListagem />} />
                        <Route path="/horario/cadastrar" element={<HorarioCadastro />} />
                        <Route path="/horario/editar/:id" element={<HorarioCadastro />} />

                        <Route path="/apontamentos" element={<AtividadeApontamentoFiltroListagem />} />
                        <Route path="/meusApontamentos" element={<AtividadeMeusApontamentosListagem />} />
                        <Route path="/apontamento/cadastrar" element={<AtividadeApontamentoCadastro />} />
                        <Route path="/apontamento/editar/:id" element={<AtividadeApontamentoCadastro />} />

                        <Route path="/feriadosadm" element={<FeriadoAdmListagem />} />
                        <Route path="/feriadoadm/cadastrar" element={<FeriadoAdmCadastro />} />
                        <Route path="/feriadoadm/editar/:id" element={<FeriadoAdmCadastro />} />

                        <Route path="/feriados" element={<FeriadoListagem />} />
                        <Route path="/feriado/cadastrar" element={<FeriadoCadastro />} />
                        <Route path="/feriado/editar/:id" element={<FeriadoCadastro />} />

                        <Route path="/marcasVeiculo" element={<MarcaVeiculoListagem />} />
                        <Route path="/marcaVeiculo/cadastrar" element={<MarcaVeiculoCadastro />} />
                        <Route path="/marcaVeiculo/editar/:id" element={<MarcaVeiculoCadastro />} />

                        <Route path="/veiculos" element={<VeiculoListagem />} />
                        <Route path="/veiculo/cadastrar" element={<VeiculoCadastro />} />
                        <Route path="/veiculo/editar/:id" element={<VeiculoCadastro />} />
                        <Route path="/veiculo/manutencaoPendente" element={<ManutencaoPendenteListagem />} />

                        <Route path="/itemInspecaoFrota" element={<ItemInspecaoFrotaListagem />} />
                        <Route path="/itemInspecaoFrota/cadastrar" element={<ItemInspecaoFrotaCadastro />} />
                        <Route path="/itemInspecaoFrota/editar/:id" element={<ItemInspecaoFrotaCadastro />} />

                        <Route path="/manutencaoVeiculo" element={<ManutencaoVeiculoListagem />} />
                        <Route path="/manutencaoVeiculo/cadastrar" element={<ManutencaoVeiculoCadastro />} />
                        <Route path="/manutencaoVeiculo/editar/:id" element={<ManutencaoVeiculoCadastro />} />

                        <Route path="/veiculoViagem" element={<VeiculoViagemListagem />} />
                        <Route path="/veiculoViagem/editar/:id" element={<VeiculoViagemConsultar />} />
                        <Route path="/veiculoViagem/dashboard" element={<VeiculoViagemDashboardPage />} />
                        <Route path="/veiculoViagem/rastreamento" element={<VeiculoViagemRastreamentoPage />} />

                        <Route path="/frotas/dashboard" element={<GestaoFrotasDashboard />} />

                        <Route path="/estagios" element={<EstagioListagem />} />
                        <Route path="/estagio/cadastrar" element={<EstagioCadastro />} />
                        <Route path="/estagio/editar/:id" element={<EstagioCadastro />} />

                        <Route path="/roteiros" element={<RoteiroListagem />} />
                        <Route path="/roteiro/cadastrar" element={<RoteiroCadastro />} />
                        <Route path="/roteiro/editar/:id" element={<RoteiroCadastro />} />

                        <Route path="/pedidos" element={<PedidoListagem />} />
                        <Route path="/pedido/cadastrar" element={<PedidoCadastro />} />
                        <Route path="/pedido/editar/:id" element={<PedidoCadastro />} />

                        <Route path="/gerarOP" element={<GerarOP />} />
                        <Route path="/ordensProducao" element={<OrdemProducaoListagem />} />
                        <Route path="/ordemProducao/editar/:id" element={<OrdemProducaoCadastro />} />

                        <Route path="/apontamentoOp/escolherEstagio" element={<EscolherEstagio />} />
                        <Route path="/apontamentoOp/listagem/:idEstagio" element={<EstagiosApontamentoListagem />} />
                        <Route path="/apontamentoOp/apontar/:idEstagio" element={<EstagioApontamentoCadastro />} />

                        <Route path="/operacoesProducao" element={<OperacaoProducaoListagem />} />
                        <Route path="/operacaoProducao/cadastrar" element={<OperacaoProducaoCadastro />} />
                        <Route path="/operacaoProducao/editar/:id" element={<OperacaoProducaoCadastro />} />

                        <Route path="/horariosDia" element={<HorarioDiaListagem />} />
                        <Route path="/horarioDia/cadastrar" element={<HorarioDiaCadastro />} />
                        <Route path="/horarioDia/editar/:id" element={<HorarioDiaCadastro />} />

                        <Route path="/defeitosFabricacao" element={<DefeitoFabricacaoListagem />} />
                        <Route path="/defeitoFabricacao/cadastrar" element={<DefeitoFabricacaoCadastro />} />
                        <Route path="/defeitoFabricacao/editar/:id" element={<DefeitoFabricacaoCadastro />} />

                        <Route path="/motivosParada" element={<MotivoParadaListagem />} />
                        <Route path="/motivoParada/cadastrar" element={<MotivoParadaCadastro />} />
                        <Route path="/motivoParada/editar/:id" element={<MotivoParadaCadastro />} />

                        <Route path="/metasProducao" element={<MetaProducaoListagem />} />
                        <Route path="/metaProducao/cadastrar" element={<MetaProducaoCadastro />} />
                        <Route path="/metaProducao/editar/:id" element={<MetaProducaoCadastro />} />

                        <Route path="/apontamentosOperacao" element={<ApontamentoOperacaoListagem />} />
                        <Route path="/apontamentosDefeito" element={<ApontamentoDefeitoListagem />} />
                        <Route path="/apontamentosParada" element={<ApontamentoMotivoParadaListagem />} />

                        <Route path="/metaProducao/dashboard" element={<MetaProducaoDashboard />} />
                        <Route path="/metaProducao/defeitoDashboard" element={<MetaProducaoDefeitoDashboard />} />

                        <Route path="/inspecaoQualidade" element={<InspecaoQualidadeListagem />} />
                        <Route path="/inspecaoQualidade/cadastrar" element={<InspecaoQualidadeCadastro />} />
                        <Route path="/inspecaoQualidade/editar/:id" element={<InspecaoQualidadeCadastro />} />

                        <Route path="/planoInspecao" element={<PlanoInspecaoListagem />} />
                        <Route path="/planoInspecao/cadastrar" element={<PlanoInspecaoCadastro />} />
                        <Route path="/planoInspecao/editar/:id" element={<PlanoInspecaoCadastro />} />

                        <Route path="/recebimento" element={<RecebimentoListagem />} />
                        <Route path="/recebimento/cadastrar" element={<RecebimentoCadastro />} />
                        <Route path="/recebimento/editar/:id" element={<RecebimentoCadastro />} />

                        <Route path="/qualidade/produtoAcabado" element={<QualidadeProdutoAcabadoListagem />} />
                        <Route path="/qualidade/produtoAcabado/cadastrar" element={<QualidadeProdutoAcabadoCadastro />} />
                        <Route path="/qualidade/produtoAcabado/editar/:id" element={<QualidadeProdutoAcabadoCadastro />} />

                        <Route path="/local" element={<LocalListagem />} />
                        <Route path="/local/cadastrar" element={<LocalCadastro />} />
                        <Route path="/local/editar/:id" element={<LocalCadastro />} />

                        <Route path="/classificacaoFiscal" element={<ClassificacaoFiscalListagem />} />
                        <Route path="/classificacaoFiscal/cadastrar" element={<ClassificacaoFiscalCadastro />} />
                        <Route path="/classificacaoFiscal/editar/:id" element={<ClassificacaoFiscalCadastro />} />

                        <Route path="/condicaoPagamento" element={<CondicaoPagamentoListagem />} />
                        <Route path="/condicaoPagamento/cadastrar" element={<CondicaoPagamentoCadastro />} />
                        <Route path="/condicaoPagamento/editar/:id" element={<CondicaoPagamentoCadastro />} />

                        <Route path="/formaPagamento" element={<FormaPagamentoListagem />} />
                        <Route path="/formaPagamento/cadastrar" element={<FormaPagamentoCadastro />} />
                        <Route path="/formaPagamento/editar/:id" element={<FormaPagamentoCadastro />} />

                        <Route path="/serieNotaFiscal" element={<SerieNotaFiscalListagem />} />
                        <Route path="/serieNotaFiscal/cadastrar" element={<SerieNotaFiscalCadastro />} />
                        <Route path="/serieNotaFiscal/editar/:id" element={<SerieNotaFiscalCadastro />} />

                        <Route path="/transacaoNotaFiscal" element={<TransacaoNotaFiscalListagem />} />
                        <Route path="/transacaoNotaFiscal/cadastrar" element={<TransacaoNotaFiscalCadastro />} />
                        <Route path="/transacaoNotaFiscal/editar/:id" element={<TransacaoNotaFiscalCadastro />} />

                        <Route path="/unidadeOrganizacionalCertificado" element={<UnidadeOrganizacionalCertificadoCadastro />} />
                        <Route path="/parametrosFiscais" element={<ParametrosFiscaisCadastro />} />

                        <Route path="/fiscal/operacoes" element={<CicloFiscal />} />
                        <Route path="/notaFiscalSaida/cartaCorrecao/:id" element={this.props.acoes.some(acao => acao.sigla === 'NOTA_FISCAL_SAIDA_CORRIGIR')
                            ? <NotaFiscalSaidaCartaCorrecao /> : <div className="p-3">Sem permissão para emitir cartas de correção.</div>} />
                        <Route path="/notaFiscalSaida/editar/:id" element={this.props.acoes.some(acao => acao.sigla === 'NOTA_FISCAL_SAIDA_GERENCIAR')
                            ? <NotaFiscalSaidaEdicao /> : <div className="p-3">Sem permissão para editar notas fiscais.</div>} />
                        <Route path="/notaFiscalSaida/emitir" element={this.props.acoes.some(acao => acao.sigla === 'NOTA_FISCAL_SAIDA_GERENCIAR')
                            ? <NotaFiscalSaidaEmissao /> : <div className="p-3">Sem permissão para emitir notas fiscais.</div>} />
                        <Route path="/notaFiscalSaida" element={<NotaFiscalSaidaListagem />} />
                        <Route path="/notaFiscalSaida/consultar/:id" element={<NotaFiscalSaidaConsulta />} />

                        <Route path="/representante" element={<RepresentanteListagem />} />
                        <Route path="/representante/cadastrar" element={<RepresentanteCadastro />} />
                        <Route path="/representante/editar/:id" element={<RepresentanteCadastro />} />

                        <Route path="/patrimonio" element={<PatrimonioListagem />} />
                        <Route path="/patrimonio/cadastrar" element={<PatrimonioCadastro />} />
                        <Route path="/patrimonio/editar/:id" element={<PatrimonioCadastro />} />

                        <Route path="/movimentoPatrimonio" element={<MovimentoPatrimonioListagem />} />

                        <Route path="/emprestimoPatrimonio" element={<EmprestimoPatrimonioListagem />} />
                        <Route path="/emprestimoPatrimonio/cadastrar" element={<EmprestimoPatrimonioCadastro />} />
                        <Route path="/emprestimoPatrimonio/editar/:id" element={<EmprestimoPatrimonioCadastro />} />

                        <Route path="/itemEmprestimo" element={<ItemEmprestimoListagem />} />

                        <Route path="/estoqueInutilizavel" element={<EstoqueInutilizavelConsulta />} />

                        <Route path="/cte" element={<CteListagem />} />
                        <Route path="/cte/editar/:id" element={<CteCadastro />} />

                        <Route path="/mdfe" element={<MdfeListagem />} />
                        <Route path="/mdfe/editar/:id" element={<MdfeCadastro />} />

                        <Route path="/coleta" element={<ColetaListagem />} />
                        <Route path='/coleta/cadastrar' element={<ColetaCadastro />} />
                        <Route path='/coleta/editar/:id' element={<ColetaCadastro />} />

                        <Route path="/rota" element={<RotaListagem />} />
                        <Route path='/rota/cadastrar' element={<RotaCadastro />} />
                        <Route path="/rota/editar/:id" element={<RotaCadastro />} />

                        <Route path="/rastreamentoVeiculo" element={<RastreamentoPage />} />

                        <Route path="/itemManutencaoVeiculo" element={<ItemManutencaoVeiculoListagem />} />

                        <Route path="/nivelaprovacao" element={<NivelAprovacaoListagem />} />
                        <Route path="/nivelaprovacao/cadastrar" element={<NivelAprovacaoCadastro />} />
                        <Route path="/nivelaprovacao/editar/:id" element={<NivelAprovacaoCadastro />} />

                        <Route path="/centrocusto" element={<CentroCustoListagem />} />
                        <Route path="/centrocusto/cadastrar" element={<CentroCustoCadastro />} />
                        <Route path="/centrocusto/editar/:id" element={<CentroCustoCadastro />} />

                        <Route path="/aprovacaofaixavalores" element={<AprovacaoFaixaValoresListagem />} />
                        <Route path="/aprovacaofaixavalores/editar/:id" element={<AprovacaoFaixaValoresCadastro />} />

                        <Route path="/viagemDespesa" element={<ViagemDespesaListagem />} />

                        <Route path="/viagem" element={<ViagemListagem />} />
                        <Route path="/viagem/cadastrar" element={<ViagemCadastro />} />
                        <Route path="/viagem/editar/:id" element={<ViagemCadastro />} />

                        <Route path="/viagemaprovacao" element={<ViagemAprovacaoListagem />} />

                        <Route path="/viagemDespesaAprovacao" element={<ViagemDespesaAprovacaoListagem />} />

                        <Route path="/viagemTipoDespesa" element={<ViagemTipoDespesaListagem />} />
                        <Route path="/viagemTipoDespesa/cadastrar" element={<ViagemTipoDespesaCadastro />} />
                        <Route path="/viagemTipoDespesa/editar/:id" element={<ViagemTipoDespesaCadastro />} />

                        <Route path="/minhasViagens" element={<MinhasViagensListagem />} />

                        <Route path="/helpdeskTipoChamado" element={<HelpdeskTipoChamadoListagem />} />
                        <Route path="/helpdeskTipoChamado/cadastrar" element={<HelpdeskTipoChamadoCadastro />} />
                        <Route path="/helpdeskTipoChamado/editar/:id" element={<HelpdeskTipoChamadoCadastro />} />

                        <Route path="/helpdeskChamado" element={<HelpdeskChamadoListagem />} />
                        <Route path="/helpdeskChamado/editar/:id" element={<HelpdeskChamadoCadastro />} />

                        <Route path="/helpdeskMeusChamados" element={<HelpdeskMeusChamadosListagem />} />

                        <Route path="/helpdeskBatePapo/:id" element={<HelpdeskBatePapoPage />} />

                        <Route path="/processo" element={<ProcessoListagem />} />
                        <Route path="/processo/cadastrar" element={<ProcessoCadastro />} />
                        <Route path="/processo/editar/:id" element={<ProcessoCadastro />} />

                        <Route path="/unidadeOrganizacional" element={<UnidadeOrganizacionalListagem />} />
                        <Route path="/unidadeOrganizacional/cadastrar" element={<UnidadeOrganizacionalCadastro />} />
                        <Route path="/unidadeOrganizacional/editar/:id" element={<UnidadeOrganizacionalCadastro />} />

                        <Route path="/indicador" element={<IndicadorListagem />} />
                        <Route path="/indicador/cadastrar" element={<IndicadorCadastro />} />
                        <Route path="/indicador/editar/:id" element={<IndicadorCadastro />} />
                        <Route path="/indicador/dashboard/:id" element={<IndicadorDashboardPage />} />
                        <Route path="/indicador/minhasAnalises" element={<IndicadorMinhasAnalisesColetasListagem />} />
                        <Route path="/indicador/minhasColetas" element={<IndicadorMinhasColetasListagem />} />

                        <Route path="/categoriaDocumento" element={<CategoriaDocumentoListagem />} />
                        <Route path="/categoriaDocumento/cadastrar" element={<CategoriaDocumentoCadastro />} />
                        <Route path="/categoriaDocumento/editar/:id" element={<CategoriaDocumentoCadastro />} />


                        <Route path="/documento" element={<DocumentoListagem />} />
                        <Route path="/documento/cadastrar" element={<DocumentoCadastro />} />
                        <Route path="/documento/editar/:id" element={<DocumentoPropriedades />} />
                        <Route path="/documento/minhasPendencias" element={<DocumentosPendenciasListagem />} />
                        <Route path="documentoVersao/editar/:id" element={<DocumentoFluxoPage />} />
                        <Route path="/documento/pastas" element={<DocumentoPastaPage />} />
                        <Route path="/documento/lixeira" element={<DocumentoPastaLixeiraPage />} />
                        <Route path="/documento/solicitacaoRevisao" element={<DocumentoSolicitacaoRevisaoListagem />} />
                        <Route path="/documento/dashboard" element={<DocumentoDashboardPage />} />
                        <Route path="/driveCallback" element={<CallbackDrivePage />} />
                    </Routes>

                </div>

                <div className="layout-mask"></div>
            </div>
        );
    }
}

export default Menu;
